import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BoardTaskIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.68319 4.52065C4.59194 3.5457 5.8861 3 7.41423 3H15.2001C16.7318 3 18.0265 3.54539 18.9349 4.52091C19.838 5.49084 20.3076 6.82974 20.3076 8.33204V15.6679C20.3076 17.1702 19.838 18.5092 18.9347 19.4791C18.0262 20.4546 16.7312 21 15.1992 21H7.41423C5.88251 21 4.58797 20.4546 3.67984 19.479C2.77693 18.5091 2.30762 17.1702 2.30762 15.6679V8.33204C2.30762 6.82898 2.77947 5.49019 3.68319 4.52065ZM4.69603 5.46473C4.07092 6.13538 3.69223 7.11647 3.69223 8.33204V15.6679C3.69223 16.8844 4.06941 17.8653 4.69332 18.5356C5.312 19.2003 6.22461 19.6154 7.41423 19.6154H15.1992C16.3893 19.6154 17.3024 19.2002 17.9215 18.5355C18.5456 17.8652 18.923 16.8843 18.923 15.6679V8.33204C18.923 7.1157 18.5456 6.13474 17.9216 5.46447C17.3026 4.79977 16.3897 4.38462 15.2001 4.38462H7.41423C6.22911 4.38462 5.31612 4.79947 4.69603 5.46473Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2676 15.0505C11.2676 14.6681 11.5775 14.3582 11.9599 14.3582H15.9386C16.321 14.3582 16.6309 14.6681 16.6309 15.0505C16.6309 15.4328 16.321 15.7428 15.9386 15.7428H11.9599C11.5775 15.7428 11.2676 15.4328 11.2676 15.0505Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85261 13.1909C10.1229 13.4614 10.1227 13.8997 9.85233 14.17L8.37218 15.6493C8.10179 15.9194 7.66356 15.9194 7.39325 15.6491L6.63344 14.8893C6.36307 14.6189 6.36307 14.1805 6.63344 13.9102C6.9038 13.6398 7.34214 13.6398 7.61251 13.9102L7.88294 14.1806L8.87352 13.1906C9.14396 12.9204 9.58233 12.9205 9.85261 13.1909Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85261 8.35185C10.1229 8.62229 10.1227 9.06064 9.85233 9.33092L8.37218 10.8101C8.10179 11.0803 7.66356 11.0803 7.39325 10.81L6.63344 10.0502C6.36307 9.7798 6.36307 9.34146 6.63344 9.0711C6.9038 8.80073 7.34214 8.80073 7.61251 9.0711L7.88294 9.34153L8.87352 8.35155C9.14396 8.08127 9.58233 8.0814 9.85261 8.35185Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2676 10.2152C11.2676 9.8329 11.5775 9.52295 11.9599 9.52295H15.9386C16.321 9.52295 16.6309 9.8329 16.6309 10.2152C16.6309 10.5976 16.321 10.9076 15.9386 10.9076H11.9599C11.5775 10.9076 11.2676 10.5976 11.2676 10.2152Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default BoardTaskIcon;
